import type { RouteObject } from 'react-router';

import { ReportingPage } from './Reporting';

/**
 * `/subscriptions`. One `RouteObject`, so the file is `.route.tsx` singular.
 *
 * The path is the URL the sitemap fixes; `reporting` is the mockup pack's file
 * name and never reaches an address bar — a bucket is file organisation, not a
 * segment.
 *
 * It sits inside the console layout route, which already runs the guard chain.
 * Both bands are authorized by their owning service on the request itself.
 */
export const reportingRoute: RouteObject = {
  path: 'subscriptions',
  element: <ReportingPage />,
};
